import React from 'react'
import Layout from '../../components/Layout/Layout'

const Orders = () => {
  return (
    <Layout>
    <div>Orders</div>
    </Layout>   
  )
}

export default Orders